import React, { useContext, useEffect, useRef, useState } from 'react'
import './Feedback.css'
import { ICallout } from '../../models/Callout'
import useCallout from '../../hooks/useCallout'
import LoaderContext from '../context/FormLoader'
import CalloutDisplay from '../common/CalloutDisplay'
import Conditional from '../common/Conditional'

const CreateFeedbackFooter = () => {
  const [data, setData] = useState<ICallout[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [getCallout] = useCallout('Feedback', 'After')
  const loader = useContext(LoaderContext)
  const mountedRef = useRef(false)

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setData(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return (
    <>
      <Conditional if={!isLoading}>
        {data &&
          data.map((c, i) => (
            <CalloutDisplay
              key={i}
              className=""
              content={c.content}
              name="Feedback"
            />
          ))}
      </Conditional>
    </>
  )
}

export default CreateFeedbackFooter
